import React from "react";
import Breadcrumbs from "../../../../../components/Breadcrumbs";
import DeleteModal from "../../../../../components/modelpopup/deletePopup";
import BudgetTable from "./BudgetTable";
import AddModal from "./AddModal";
import EditBudgetModal from "./EditBudgetModal";

const Record50 = () => {
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="سجل 50"
            title="الرئيسية"
            subtitle="سجل 50"
            modal="#add_budgets"
            name="Add Budgets"
          />
          <BudgetTable />
        </div>
      </div>
      <AddModal />
      <EditBudgetModal />
      <DeleteModal Name="Delete" />
    </>
  );
};

export default Record50;
